// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__cWSbS","Cancel":"schedule_Cancel__2EbDr"};